import { useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import { updateSubscription } from '../../reducers/subscription';
import { completeStep } from '../../reducers/steps';
import { trackPageView } from '../../services/tracking';
import { updateReducerAndForm } from '../../services/subscription';

import { Input } from '../input';
import { Button } from '../button';
import { FormActions } from '../formActions';
import { PageHeader } from '../pageHeader';
import { PageBack } from '../pageBack';

import Summary from '../summary';

const CustomFrequency = (props) => {
  const formikRef = useRef();
  const dispatch = useDispatch();

  const subscription = useSelector((state) => state.subscription);
  const initialValues = { ...subscription };

  const steps = useSelector((state) => state.steps);

  let backUrl, backDescription;
  if(steps[3].complete){
    backUrl = '/plano';
    backDescription = 'Sua caixinha';
  }
  else {
    backUrl = '/frequencia';
    backDescription = 'Frequência';
  }

  const validate = (values) => {
    const errors = {};

    if (!values.frequency){
      errors.frequency = 'Escolha uma frequência para continuar';
    }
    else if(values.frequency < 7 || values.frequency > 90) {
      errors.frequency = 'Escolha uma frequência entre 7 e 90 dias';
    }

    return errors;
  }

  const handleChange = (e) => {
    updateReducerAndForm({
      frequency: parseInt(e.target.value)
    }, formikRef.current.setFieldValue);
  }

  const handleSubmit = (values) => {
    dispatch(completeStep(3));

    props.history.push('/entrega');
  }

  useEffect(() => {
    dispatch(updateSubscription({ frequencyPage: 'customFrequency' }));

    trackPageView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Formik
        innerRef={formikRef}
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validate={validate}
      >
        {({ values }) => (
          <Form>
            <PageHeader>
              <small>Frequência</small>
              <h1>Com qual frequência você quer receber os seus cafés?</h1>
              <p>Você só será cobrado 1 vez a cada periodo escolhido.</p>
            </PageHeader>

            <PageBack to="/frequencia" text="Voltar para as frequências" />

            <Input
              label="Sua frequência ideal (em dias)"
              name="frequency"
              onBlur={handleChange}
            />

            <Summary />

            <FormActions backUrl={backUrl} backDescription={backDescription}>
              <Button
                type="submit"
                icon="angle-right"
                align="right"
                description="Endereço de entrega"
              >
                Continuar
              </Button>
            </FormActions>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default withRouter(CustomFrequency);
